'use strict';
import $ from 'jquery';
global.$ = $;

var footerToBottom = {
  _footer: $('.js-site-footer'),
  _window: $(window),
  _timeout: null,
  // This is a public function as it is called after updating content dynamically
  // (eg. switching tabs or ajax)
  fixToBottom: function() {
    var self = this;
    clearTimeout(self._timeout);
    self._timeout = setTimeout(function() {
      self._footer.removeClass('fixed-bottom'); // Can't check if footer is in bottom if it is fixed there
      self._footer.toggleClass('fixed-bottom', self._footer.offset().top + self._footer.outerHeight(true) < self._window.height());
    }, 100);
  },
  init: function() {
    var self = this;

    self.fixToBottom();

    let observer = new MutationObserver((mutationsList, observer) => {
      mutationsList.forEach((mutation) => {
        self.fixToBottom();
      })
    });
    observer.observe(document.body, { attributes: false, childList: true, subtree: true, characterData: false });

    self._window.resize(function() {
      self.fixToBottom();
    });
  }
};
module.exports = footerToBottom;
